import _get from "@babel/runtime/helpers/get";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Writable } from 'stream';
import MicrophoneStream from 'microphone-stream';
import audioContext from 'audio-context';
import keyboardjs from 'keyboardjs';
import vad from 'voice-activity-detection';
import DropStream from 'drop-stream';
import { WorkerBasedMumbleClient } from './worker-client';
var VoiceHandler = /*#__PURE__*/function (_Writable) {
  function VoiceHandler(client, settings) {
    var _this;
    _classCallCheck(this, VoiceHandler);
    _this = _callSuper(this, VoiceHandler, [{
      objectMode: true
    }]);
    _this._client = client;
    _this._settings = settings;
    _this._outbound = null;
    _this._mute = false;
    return _this;
  }
  _inherits(VoiceHandler, _Writable);
  return _createClass(VoiceHandler, [{
    key: "setMute",
    value: function setMute(mute) {
      this._mute = mute;
      if (mute) {
        this._stopOutbound();
      }
    }
  }, {
    key: "_getOrCreateOutbound",
    value: function _getOrCreateOutbound() {
      if (this._mute) {
        throw new Error('tried to send audio while self-muted');
      }
      if (!this._outbound) {
        if (!this._client) {
          this._outbound = DropStream.obj();
          this.emit('started_talking');
          return this._outbound;
        }
        if (this._client instanceof WorkerBasedMumbleClient) {
          // Note: the samplesPerPacket argument is handled in worker.js and not passed on
          this._outbound = this._client.createVoiceStream(this._settings.samplesPerPacket);
        } else {
          this._outbound = this._client.createVoiceStream();
        }
        this.emit('started_talking');
      }
      return this._outbound;
    }
  }, {
    key: "_stopOutbound",
    value: function _stopOutbound() {
      if (this._outbound) {
        this.emit('stopped_talking');
        this._outbound.end();
        this._outbound = null;
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      this._stopOutbound();
      callback();
    }
  }]);
}(Writable);
export var ContinuousVoiceHandler = /*#__PURE__*/function (_VoiceHandler) {
  function ContinuousVoiceHandler(client, settings) {
    _classCallCheck(this, ContinuousVoiceHandler);
    return _callSuper(this, ContinuousVoiceHandler, [client, settings]);
  }
  _inherits(ContinuousVoiceHandler, _VoiceHandler);
  return _createClass(ContinuousVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      if (this._mute) {
        callback();
      } else {
        this._getOrCreateOutbound().write(data, callback);
      }
    }
  }]);
}(VoiceHandler);
export var PushToTalkVoiceHandler = /*#__PURE__*/function (_VoiceHandler2) {
  function PushToTalkVoiceHandler(client, settings) {
    var _this2;
    _classCallCheck(this, PushToTalkVoiceHandler);
    _this2 = _callSuper(this, PushToTalkVoiceHandler, [client, settings]);
    _this2._key = settings.pttKey;
    _this2._pushed = false;
    _this2._keydown_handler = function () {
      return _this2._pushed = true;
    };
    _this2._keyup_handler = function () {
      _this2._stopOutbound();
      _this2._pushed = false;
    };
    keyboardjs.bind(_this2._key, _this2._keydown_handler, _this2._keyup_handler);
    return _this2;
  }
  _inherits(PushToTalkVoiceHandler, _VoiceHandler2);
  return _createClass(PushToTalkVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      if (this._pushed && !this._mute) {
        this._getOrCreateOutbound().write(data, callback);
      } else {
        callback();
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      var _this3 = this;
      _superPropGet(PushToTalkVoiceHandler, "_final", this, 3)([function (e) {
        keyboardjs.unbind(_this3._key, _this3._keydown_handler, _this3._keyup_handler);
        callback(e);
      }]);
    }
  }]);
}(VoiceHandler);
export var VADVoiceHandler = /*#__PURE__*/function (_VoiceHandler3) {
  function VADVoiceHandler(client, settings) {
    var _this4;
    _classCallCheck(this, VADVoiceHandler);
    _this4 = _callSuper(this, VADVoiceHandler, [client, settings]);
    var level = settings.vadLevel;
    var self = _this4;
    _this4._vad = vad(audioContext(), theUserMedia, {
      onVoiceStart: function onVoiceStart() {
        console.log('vad: start');
        self._active = true;
      },
      onVoiceStop: function onVoiceStop() {
        console.log('vad: stop');
        self._stopOutbound();
        self._active = false;
      },
      onUpdate: function onUpdate(val) {
        self._level = val;
        self.emit('level', val);
      },
      noiseCaptureDuration: 0,
      minNoiseLevel: level,
      maxNoiseLevel: level
    });
    // Need to keep a backlog of the last ~150ms (dependent on sample rate)
    // because VAD will activate with ~125ms delay
    _this4._backlog = [];
    _this4._backlogLength = 0;
    _this4._backlogLengthMin = 1024 * 6 * 4; // vadBufferLen * (vadDelay + 1) * bytesPerSample
    return _this4;
  }
  _inherits(VADVoiceHandler, _VoiceHandler3);
  return _createClass(VADVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      if (this._active && !this._mute) {
        if (this._backlog.length > 0) {
          var _iterator = _createForOfIteratorHelper(this._backlog),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var oldData = _step.value;
              this._getOrCreateOutbound().write(oldData);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          this._backlog = [];
          this._backlogLength = 0;
        }
        this._getOrCreateOutbound().write(data, callback);
      } else {
        // Make sure we always keep the backlog filled if we're not (yet) talking
        this._backlog.push(data);
        this._backlogLength += data.length;
        // Check if we can discard the oldest element without becoming too short
        if (this._backlogLength - this._backlog[0].length > this._backlogLengthMin) {
          this._backlogLength -= this._backlog.shift().length;
        }
        callback();
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      var _this5 = this;
      _superPropGet(VADVoiceHandler, "_final", this, 3)([function (e) {
        _this5._vad.destroy();
        callback(e);
      }]);
    }
  }]);
}(VoiceHandler);
var theUserMedia = null;
export function initVoice(onData) {
  return window.navigator.mediaDevices.getUserMedia({
    audio: true
  }).then(function (userMedia) {
    theUserMedia = userMedia;
    var micStream = new MicrophoneStream(userMedia, {
      objectMode: true,
      bufferSize: 1024
    });
    micStream.on('data', function (data) {
      onData(Buffer.from(data.getChannelData(0).buffer));
    });
    return userMedia;
  });
}